import clsx from 'clsx'
import { forwardRef, type AnchorHTMLAttributes, type ReactNode } from 'react'

import { OpenNew } from '@/assets/icons'

export type LinkSize = 'xs' | 'sm' | 'base'

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  size?: LinkSize
  external?: boolean
  children: ReactNode
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link({ size = 'sm', external, children, className, target, rel, ...props }, ref) {
  return (
    <a
      ref={ref}
      {...props}
      data-ds-component="Link"
      data-ds-size={size}
      target={external ? '_blank' : target}
      rel={external ? 'noopener noreferrer' : rel}
      className={clsx(
        'inline font-medium underline',
        'text-brand-700 hover:text-brand-800 transition-colors duration-150',
        'focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500',
        size === 'xs' && 'text-xs',
        size === 'sm' && 'text-sm tracking-[-0.15px]',
        size === 'base' && 'text-base tracking-[-0.32px]',
        className
      )}
    >
      {children}
      {external && (
        <span aria-hidden="true" className={clsx('inline-flex items-center align-middle -translate-y-[2px] shrink-0', size === 'xs' ? 'ml-0.5' : 'ml-1')}>
          <OpenNew className={clsx(size === 'xs' && 'h-3.5 w-3.5', size === 'sm' && 'h-4 w-4', size === 'base' && 'h-[18px] w-[18px]')} />
        </span>
      )}
    </a>
  )
})
